<template>
    <div class="card tour-simple-card">
        <div v-if="badge" class="badge-discount">
            <span>{{ badge }}</span>
        </div>
        <img src="/assets/images/backgrounds/tour-3.png" class="card-img-top" :alt="title">
        <div class="card-body">
            <h4 class="card-title">{{ title }}</h4>
            <ul class="list-unstyled">
                <li>
                    <div class="sort-picker d-flex">
                        <span class="text-secondary ">Type:</span>
                        Fixed
                    </div>
                </li>
                <li>
                    <div class="sort-picker d-flex">
                        <span class="text-secondary ">Duration:</span>
                        1 Week
                    </div>
                </li>
                <li>
                    <div class="d-flex">
                        <span class="text-secondary ">Start Date:</span>
                        <DatePicker class="datepicker ms-2"
                                    color="red"
                                    :value="new Date()"
                                    :min-date="new Date()"
                                    :masks="{
                        title: 'MMMM YYYY',
                        weekdays: 'WWW'
                    }" >
                            <template v-slot="{ inputValue, inputEvents }">
                                <a href="javascript:void(0);" v-on="inputEvents" class="filter-value">{{ inputValue }}</a>
                            </template>
                        </DatePicker>
                    </div>
                </li>
            </ul>
            <div class="card-actions">
                <a class="btn btn-primary w-100" @click="$emit('buy')">Quick Buy</a>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd.min";

export default {
    name: "MembershipCard",
    components: {DatePicker},
    props: {
        id: {
            required: true
        },
        title: {
            type: String,
            required: true
        },
        badge: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped>

</style>
